import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

const authRoute = ({ component: Component, render, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        let form = props.location.state || { from: { pathname: '/' } }
        return isAuthenticated ? (
          <Redirect to={form} />
        ) : (
          Component ? (
            <Component {...props} />
          ) : (
            render(props)
          )
        )
      }}
    />
  )
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  }
}

export default connect(mapStateToProps)(authRoute)
